import React, { useRef, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ConditionModal from '../../../FlowConfigurationInputs/ConditionModal/ConditionModal'
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       process -  boolean
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function If({ action, variables, setOpenVariable, process, variableRender }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.IF.';
    const [openAdd, setOpenAdd] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [conditions, setConditions] = useState([]);
    const selectedIndex = useRef(0);
    const conditionInfo = useRef({});
    const selectedCondition = useRef(null);
    useEffect(() => {
        if (!action.fields.conditions) { action.fields.conditions = { value: [], type: 'CONDITION' }; setConditions([]); }
        else { setConditions(action.fields.conditions.value); }
    }, [action]);
    const handleAddClick = (e) => {
        conditionInfo.current = { condition: '', operator: 'eq', fields: { firstValue: { value: '' }, secondValue: { value: '' } }, firstBool: true, secondBool: true, logic: 'last' }
        setOpenAdd(true);
    }
    const handleUpdateClick = (e, index) => {
        selectedIndex.current = index;
        let el = e.target;
        while (el.className !== 'condition-picker') {
            el = el.parentElement;
        }
        el.classList.add('condition-selected');
        selectedCondition.current = el;
        setOpenUpdate(true);
    }
    const handleAdd = (e) => {
        let index = conditions.length - 1;
        if (index > -1) {
            conditions[index].logic = 'and';
        }
        let newConditions = [...conditions, { ...conditionInfo.current }];
        action.fields.conditions.value = newConditions;
        setConditions(newConditions);
        setOpenAdd(false);
    }
    const handleUpdate = (e) => { closeUpdate(); }
    const handleDelete = (e) => {
        let n = conditions.length;
        let i = selectedIndex.current;
        if (n > 1 && i === n - 1) {
            conditions[n - 2].logic = 'last';
        }
        conditions.splice(i, 1);
        closeUpdate();
    }
    const closeUpdate = (conditionBackup) => {
        if (conditionBackup) {
            action.fields.conditions.value[selectedIndex.current] = conditionBackup
        }
        selectedCondition.current.classList.remove('condition-selected');
        setOpenUpdate(false);
    }
    const handleLogicChange = (e, index) => {
        let target = e.target;
        for (const el of target.parentNode.childNodes) {
            el.classList.remove('condition-active')
        }
        target.classList.add('condition-active')
        conditions[index].logic = target.value;
    }
    return (
        <div>
            <div className="form-element">
                <Button onClick={handleAddClick}
                    style={{ border: "none", color: "#8F94A6", fontWeight: 700, textTransform: "none" }}>
                    {t(label + 'ADD-CONDITION')}
                    <AddIcon style={{ paddingLeft: 5 }} onClick={handleAddClick} />
                </Button>
            </div>
            {conditions.map((condition, conditionI) =>
                <div key={conditionI}>
                    <div className="form-element">
                        <ConditionPicker condition={condition} onClick={(e) => { handleUpdateClick(e, conditionI) }} />
                    </div>
                    {condition.logic !== 'last' &&
                        <div className="form-element" style={{ textAlign: 'center' }}>
                            <div className="condition-tabs">
                                <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                    value="and" onClick={(e) => { handleLogicChange(e, conditionI) }}>
                                    And
                                </button>
                                <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                    value="or" onClick={(e) => { handleLogicChange(e, conditionI) }}>
                                    Or
                                </button>
                            </div>
                        </div>
                    }
                </div>
            )}
            {openAdd &&
                <ConditionModal conditionInfo={conditionInfo.current}
                    setOpen={setOpenAdd} handleAdd={handleAdd}
                    variables={variables} variableRender={variableRender} setOpenVariable={setOpenVariable}
                    process={process} />
            }
            {openUpdate &&
                <ConditionModal
                    conditionInfo={conditions[selectedIndex.current]}
                    variableRender={variableRender}
                    setOpen={setOpenUpdate} handleUpdate={handleUpdate}
                    handleDelete={handleDelete} onClose={closeUpdate}
                    variables={variables} setOpenVariable={setOpenVariable}
                    process={process} />
            }
        </div>
    )
}
export default If;
/**
 * @Description This function lets you return ConditionPicker component.
 * @Param       condition - object
 * @Param       onClick - function
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ConditionPicker({ condition, onClick }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';
    return (
        <div className="condition-picker">
            <fieldset>
                <legend>&nbsp;<span>{condition.condition}</span>&nbsp;</legend>
                <div>
                    <div>
                        <span className="condition-value">{condition.fields.firstValue.value}</span>
                        &nbsp;<span>{t(label + condition.operator.toUpperCase())}</span>&nbsp;
                        <span className="condition-value">{condition.fields.secondValue.value}</span>
                    </div>
                    <div>
                        <button onClick={onClick}><MoreVertIcon /></button>
                    </div>
                </div>
            </fieldset>
        </div>
    );
}